<template>
    <v-container fill-height class="align-start">
        <v-row no-gutters class="align-self-center mt-16">
            <v-col>
                <loading-overlay :loading="loading"></loading-overlay>
                <v-row class="justify-space-between pa-4 absolute-top align-center" no-gutters>
                    <v-col>
                        <v-row class="align-center" no-gutters>
                            <v-col class="flex-grow-0">
                                <v-img
                                    alt="logo"
                                    src="/svg/logo.svg"
                                    class="align-self-start mb-1"
                                    width="125"
                                    contain
                                ></v-img>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="text-right">
                        <p>
                            <span class="body-2 grey--text text--darken-1 d-none d-sm-inline-flex flex-wrap">Know your password?</span>
                            <router-link :to="{ name: 'login' }">
                                <v-btn
                                    href="#"
                                    class="px-sm-12 ml-4"
                                    color="primary"
                                    outlined
                                    medium
                                >
                                    Sign in
                                </v-btn>
                            </router-link>
                        </p>
                    </v-col>
                </v-row>
                <v-row class="py-12" align="center" justify="center" no-gutters>
                    <v-col class="form">
                        <v-scale-transition
                            origin="center center"
                            mode="out-in"
                            appear
                        >
                            <v-icon
                                class="mb-6"
                                size="100"
                                color="primary"
                            >
                                mdi-email-search-outline
                            </v-icon>
                        </v-scale-transition>
                        <v-fade-transition
                            appear
                        >
                            <h1 class="display-1 font-weight-bold primary--text mb-4">Check Your Email!</h1>
                        </v-fade-transition>
                        <v-fade-transition
                            appear
                        >
                            <h2 class="subtitle-1 mb-12">Instructions for resetting your password will be waiting for you there.</h2>
                        </v-fade-transition>
                        <v-fade-transition
                            appear
                        >
                            <p class="body-2 primary--text mb-0 pa-6">
                                Didn't get a password reset link in the email?
                                <br/><router-link :to="{ path: 'password-reset' }"> <strong class="try-again">Try Again</strong></router-link>
                            </p>
                        </v-fade-transition>
                    </v-col>
                </v-row>
                <v-row align="center" justify="center">
                    <v-col class="form">
                            <v-row>
                                <v-col class="d-flex justify-space-between align-center">
                                    <router-link
                                        to="/"
                                        class="caption primary--text font-weight-bold pa-4"
                                    >
                                        Home
                                    </router-link>
                                    <a
                                        href="https://www.kaoshinetwork.com/terms_of_service.html"
                                        class="caption primary--text font-weight-bold pa-4"
                                        target="_blank"
                                    >
                                        Legal
                                    </a>
                                    <a
                                        href="https://www.kaoshinetwork.com/privacy_policy.html"
                                        target="_blank"
                                        class=" caption primary--text font-weight-bold pa-4"
                                    >
                                        Privacy Policy
                                    </a>
                                </v-col>
                            </v-row>
                            <p class="caption pb-6 mb-8 grey--text">&copy; {{ year }} Kaoshi. All rights reserved. Trademarks and brands are the property of their respective owners.</p>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: "password-reset-instructions",
        data: data,
    }

    function data(){
        return {
            year: Vue.moment().year(),
            loading: false,
        }
    }
</script>

<style scoped>
.slogan {
    color:#1a224e;
    font-size: .625rem!important;
    font-weight: 400;
    letter-spacing: .1666666667em!important;
    line-height: 1rem;
    font-family: Roboto,sans-serif!important;
    margin-top: .625rem;
    margin-left: 1rem;
    margin-bottom: 0;
    white-space: nowrap;
}
.form {
    text-align: center;
    max-width: 350px;
}
.try-again {
    text-decoration: underline;
    font-style: italic;
}

@media screen and (min-width: 600px) {
    .absolute-top {
        position: fixed;
        top: 0px;
        left: 50%;
        transform: translateX(-50%);
        max-width: 1300px;
        width: 90%;
    }
}
</style>
